
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "marketplace-storefront-public-ui",
  currentProjectVersion: "static-1.13608",
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13608",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.1321",
  "client-types": "static-1.522",
  "data-fetching-client": "static-1.10170",
  "foundations-components": "static-1.8846",
  "foundations-components-legacy": "static-1.1871",
  "foundations-theming": "static-1.5036",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.95",
  "head-dlb": "static-1.5344",
  "hs-test-utils": "static-1.8577",
  "hub-http-shared-msw-handlers": "static-1.10999",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.12024",
  "I18n": "static-7.1723",
  "jasmine-runner": "static-1.6993",
  "marketplace-discovery-studio-lib": "static-1.1000",
  "marketplace-storefront-base": "static-1.13671",
  "quartz": "static-1.7753",
  "react-dlb": "static-1.96",
  "react-rhumb": "static-1.17272",
  "reactive-variable-buffer-atom": "static-1.3384",
  "reporting-testing-lib": "static-1.11556",
  "reselect": "static-3.19",
  "settings-ui-lib": "static-1.13067",
  "SharedI18nStrings": "static-1.190",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7935",
  "ui-addon-i18n": "static-1.11682",
  "ui-addon-react-router-dom": "static-1.10063",
  "unified-auth": "static-1.1368",
  "unified-auth-core-lib": "static-1.1650",
  "usage-tracker": "static-1.7877",
  "usage-tracker-core": "static-1.7727",
  "customer-data-property-utils": "static-1.8594",
  "hub-http": "static-1.6740",
  "integrations-lib": "static-1.17557",
  "marketplace-ui-common": "static-1.21151",
  "marketplace-ui-install": "static-1.1137",
  "property-management-iframe": "static-1.14605",
  "quartz-config": "static-1.1531",
  "quartz-core": "static-1.6972",
  "quartz-routing": "static-1.1183",
  "quick-fetch": "static-1.4265",
  "react": "static-7.204",
  "rpc-client-utils": "static-1.5201",
  "ts-schema": "static-1.4431",
  "ui-universal-auth": "static-1.9854",
  "UIComponents": "static-3.8970",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.529",
  "hs-promise-rejection-tracking": "static-1.6102",
  "PortalIdParser": "static-2.459",
  "raven": "static-3.6435",
  "raven-hubspot": "static-1.6742",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.4030",
  "quartz-webpack": "static-1.3977",
  "bend-plugin-quartz-routing": "static-1.831",
  "ai-components-ui-library": "static-1.10124",
  "codemirror": "static-5.108",
  "foundations-assets": "static-1.5424",
  "pulse": "static-1.1201",
  "react-codemirror": "static-1.11177",
  "ui-extensions-preview-lib": "static-1.1101",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5115",
  "floating-ui": "static-1.70",
  "foundations-theming-specialty": "static-1.2752",
  "framer-motion": "static-1.86",
  "hs-story-utils": "static-1.9959",
  "react-aria": "static-1.79",
  "react-create-root-preference": "static-1.120",
  "react-select-plus": "static-1.120",
  "react-utils": "static-2.5714",
  "react-virtualized": "static-2.114",
  "StyleGuideUI": "static-3.520",
  "tanstack-table": "static-1.68",
  "trellis-assets": "static-1.3253",
  "ui-fonts": "static-1.1286",
  "ui-images": "static-2.1295",
  "bend-plugin-foundations-theming": "static-1.3519",
  "foundations-theming-base": "static-1.4021",
  "stylex": "static-1.48",
  "HeadJS": "static-2.836",
  "hs-test-utils-bend-plugin": "static-1.3688",
  "msw": "static-1.105",
  "msw-config": "static-1.41",
  "testing-library": "static-1.167",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.237",
  "moment-timezone": "static-5.98",
  "jasmine": "static-4.4840",
  "ui-addon-video-player": "static-1.9157",
  "ai-rendering-library": "static-1.11540",
  "chirp-fetch": "static-1.2435",
  "connections-embed-lib": "static-1.1844",
  "copilot-toolkit": "static-1.12261",
  "feedback-loader": "static-1.30145",
  "laboratory-lib": "static-3.7683",
  "marketplace-embed": "static-1.23304",
  "marketplace-ui-details": "static-1.11046",
  "marketplace-ui-reviews": "static-1.21106",
  "marketplace-ui-tracking": "static-1.15321",
  "sanitize-text": "static-1.8692",
  "usage-tracker-multi": "static-1.6291",
  "usage-tracker-session-replay": "static-1.5563",
  "beacon-keepalive-queue": "static-1.237",
  "quartz-head": "static-1.1418",
  "web-vitals": "static-1.21",
  "apollo-link-hub-http": "static-2.5124",
  "immer": "static-1.107",
  "immerable": "static-1.4679",
  "highcharts": "static-8.117",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2897",
  "reporting-data": "static-1.69623",
  "cssUtils": "static-1.1158",
  "flux-actions": "static-1.383",
  "react-colorpicker": "static-2.10744",
  "react-dnd-compat": "static-1.5145",
  "redux-observable": "static-1.81",
  "ReduxMessenger": "static-2.10907",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7867",
  "icons": "static-2.715",
  "marketplace-ui-apps-core": "static-1.19683",
  "storybook-react": "static-1.46",
  "trellis-story-utils": "static-1.5031",
  "foundations-components-test-utils": "static-1.6329",
  "quartz-i18n": "static-1.1428",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.842",
  "ads-unified-auth-lib": "static-1.2304",
  "ai-mcp-auth-lib": "static-1.82",
  "cohere-settings-lib": "static-1.10541",
  "custom-vendor-connection-lib": "static-1.418",
  "gemini-settings-lib": "static-1.9892",
  "google-sheets-integration-lib": "static-1.1440",
  "microsoft-drive-auth-lib": "static-1.638",
  "slack-ui-library": "static-1.10937",
  "surveymonkey-integration-lib": "static-1.953",
  "x-ai-settings-lib": "static-1.10600",
  "fsm": "static-1.4296",
  "customer-data-objects": "static-1.8249",
  "property-translator": "static-1.5911",
  "hs-locale-management": "static-1.440",
  "frontend-preferences-client": "static-1.8458",
  "hs-promise-utils": "static-1.6125",
  "hubspot-apollo-client": "static-1.5411",
  "integrations-error-boundary-lib": "static-1.14972",
  "integrations-tracking-lib": "static-1.6163",
  "native-integrations-shared-strings": "static-1.8293",
  "sanitize": "static-1.5003",
  "superstore": "static-1.5290",
  "ui-shepherd-react": "static-3.10822",
  "ai-settings-ui-library": "static-1.8682",
  "hub-http-janus": "static-1.919",
  "hubspotter-http": "static-1.5011",
  "immutable-less": "static-1.5183",
  "marketplace-ui-client-types": "static-1.18558",
  "nav-meta": "static-1.30952",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18606",
  "ui-product-approvals-common": "static-1.1803",
  "ai-studio-lib": "static-1.12904",
  "hubspot-prosemirror": "static-1.19394",
  "integrations-reconnect-lib": "static-1.817",
  "ui-addon-iframeable": "static-1.9615",
  "ui-addon-integrations-directory-panel": "static-2.8484",
  "ui-product-approvals": "static-1.29907",
  "ui-tool-access": "static-1.10689",
  "data-agent-kit": "static-1.1045",
  "inbound-db-properties-service-client": "static-1.4188",
  "property-management-common": "static-1.6893",
  "smart-property-fill-lib": "static-1.862",
  "opentelemetry-fe-types": "static-1.335",
  "dispatcher": "static-1.150",
  "general-store": "static-6.20",
  "hs-browser-apis": "static-1.16",
  "mobile-manifest-mixins": "static-1.618",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.710",
  "quartz-auth": "static-1.1428",
  "quartz-test": "static-1.1428",
  "quartz-tracking": "static-1.1132",
  "trellis-components": "static-1.3272",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.611",
  "HubStyle": "static-2.12331",
  "bender-build-tools": "static-1.3648",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.24263",
  "ContentUtils": "static-1.69614",
  "customer-data-objects-ui-components": "static-1.13571",
  "sassPrefix": "static-1.422",
  "diff-match-patch": "static-1.7",
  "batch-promise": "static-1.2085",
  "bend-plugin-pulse": "static-1.704",
  "event-emitter": "static-1.1495",
  "fast-json-patch": "static-1.76",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5958",
  "magpie-types": "static-1.5418",
  "stylex-utils": "static-1.190",
  "trellis-theming": "static-1.1576",
  "avatar-components": "static-1.3023",
  "breeze-engine-core": "static-1.1657",
  "breeze-engine-lib": "static-1.2379",
  "breeze-onboarding-components": "static-1.1210",
  "breeze-upgrade-component-lib": "static-1.49",
  "customer-data-filters-ui": "static-1.41538",
  "customer-data-reference-ui-components": "static-1.13711",
  "data-integrations-breeze": "static-1.537",
  "embedded-academy-lib": "static-1.16189",
  "ExportDialog": "static-6.10909",
  "global-styles-ai-lib": "static-1.607",
  "highlight.js": "static-1.92",
  "markdown-it": "static-1.6",
  "marketplace-embed-ba": "static-1.1007",
  "mermaid": "static-1.47",
  "reporting-action-components": "static-1.42523",
  "reporting-snowflake": "static-1.58239",
  "reporting-ui-components": "static-2.66892",
  "reporting-visualizations": "static-1.61697",
  "trial-components-library": "static-1.14478",
  "ui-addon-teams": "static-1.22074",
  "upgrade-components-lib": "static-1.793",
  "navigation-components": "static-1.19315",
  "nest": "static-1.773",
  "simple-logging-lib": "static-1.3582",
  "nudge-client-utils": "static-1.3507",
  "fail-safe": "static-1.481",
  "app-governance-lib": "static-1.2839",
  "developer-experience-shared-components": "static-1.11080",
  "purchase-motions-components": "static-1.6717",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10963",
  "usage-tracker-anonymous": "static-1.6294",
  "usage-tracker-public": "static-1.7688",
  "amplitude-session-replay-browser": "static-1.79",
  "inbound-db-meta-service-client": "static-1.3808",
  "persist-promise": "static-1.4242",
  "reference-resolvers": "static-1.8721",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4453",
  "hubspot-apollo-cache": "static-1.870",
  "universal-page-editor-lib": "static-1.3555",
  "final-form": "static-1.85",
  "redux-toolkit": "static-1.84",
  "simple-data-table": "static-1.3933",
  "merchandise-lib": "static-1.289",
  "onboarding-scopes": "static-1.6987",
  "permissions-summary-ui-lib": "static-1.125",
  "ui-addon-draggable": "static-3.5287",
  "content-assistance-lib": "static-1.8501",
  "content-media-capture": "static-1.5882",
  "customer-data-ui-utilities": "static-1.10368",
  "emoji-mart": "static-3.9",
  "file-manager-components": "static-1.24930",
  "growth-payments-core": "static-1.26622",
  "knowledge-content-types": "static-1.8767",
  "PatternValidationJS": "static-1.3411",
  "payment-link-components": "static-1.24580",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20641",
  "ui-addon-emoji-picker": "static-1.10399",
  "ui-business-units-lib": "static-1.9631",
  "video-components-external": "static-1.12545",
  "video-data-lib": "static-1.36203",
  "navigation-messaging": "static-1.8642",
  "collaboration-sidebar": "static-1.59167",
  "trellis-ext-dnd": "static-1.632",
  "policy-lib": "static-1.7339",
  "crm-component-utils": "static-1.40332",
  "crm-properties-common-lib": "static-1.6432",
  "customer-data-properties": "static-1.53245",
  "external-options-client-types": "static-1.4476",
  "hs-resources": "static-1.731",
  "property-value-citations": "static-1.3859",
  "reference-resolvers-lite": "static-1.8648",
  "access-check-ui-lib": "static-1.2023",
  "crm-message-bus": "static-1.44254",
  "data-agent-test-utils": "static-1.589",
  "data-agent-usage-based-billing": "static-1.232",
  "data-agent-utils": "static-1.1058",
  "enrichment-settings-lib": "static-1.403",
  "smart-property-lib": "static-1.8844",
  "opentelemetry-web": "static-1.25",
  "hubspotter-http-shared-msw-handlers": "static-1.10997",
  "base-ui": "static-1.31",
  "react-day-picker": "static-1.17",
  "tanstack-virtual": "static-1.45",
  "cms-field-types": "static-1.5348",
  "content-icons-ui": "static-1.2519",
  "atom": "static-1.5608",
  "idb-keyval": "static-1.57",
  "reactive-lib": "static-1.1257",
  "trellis-migration-context": "static-1.113",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1357",
  "breeze-artifacts-sdk": "static-1.1194",
  "breeze-assistant-components": "static-1.2751",
  "getting-started-shared-tasks": "static-1.19655",
  "onboarding-journeys-lib": "static-1.1350",
  "interactive-cards": "static-1.616",
  "conversations-skeleton-state": "static-1.7648",
  "customer-data-filters-ui-msw-helpers": "static-1.23973",
  "events-data-lib": "static-1.788",
  "FormUrlGenerator": "static-2.5249",
  "framework-builder-read-service-client": "static-1.4372",
  "multi-account-reference-resolvers": "static-1.1555",
  "onboarding-tours": "static-1.17478",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14868",
  "segments-client-types": "static-1.12376",
  "academy-common-lib": "static-1.15650",
  "dashboard-lib": "static-1.83458",
  "hubspot-prosemirror-plugins": "static-1.19386",
  "reporting-plugins": "static-1.11098",
  "share-with-third-party-component-lib": "static-1.9249",
  "ui-addon-draggable-compat": "static-2.4796",
  "ui-asset-management-lib": "static-1.11644",
  "user-context": "static-1.5593",
  "reporting-reports": "static-1.69299",
  "hubs-service-types": "static-1.1801",
  "purchase-motions-api": "static-1.6720",
  "salesImages": "static-1.793",
  "signup-constants": "static-1.20109",
  "nudge-custom-function-registry": "static-1.3264",
  "nudge-renderer-utils": "static-1.3583",
  "whisper-core-api": "static-1.7733",
  "bend-plugin-fail-safe": "static-1.432",
  "framework-listing-lib": "static-2.29938",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31871",
  "apps-service-types": "static-1.4143",
  "oauth-service-types": "static-1.4671",
  "signup-ui-url-generator": "static-2.8570",
  "onboarding-tours-client": "static-1.5693",
  "one-click-checkout": "static-1.866",
  "platform-infra-nav-components": "static-1.8037",
  "purchasing-components-lib": "static-1.1118",
  "subscription-experience-data-types": "static-1.15517",
  "crm-record-cards-client": "static-1.221",
  "crm-record-cards-service-types": "static-1.3893",
  "framework-data-schema-resolvers": "static-1.7429",
  "location-customization-utils-lib": "static-1.10551",
  "redux-thunk": "static-2.87",
  "seat-types-lib": "static-1.1165",
  "react-flip-move": "static-1.85",
  "ui-coaching-tips": "static-1.29638",
  "content-media-composition-data-lib": "static-1.13686",
  "fix-webm-duration": "static-1.36",
  "notification-sounds": "static-1.4964",
  "react-immutable-render-mixin": "static-1.9",
  "poll-commands": "static-1.4011",
  "ui-addon-opt": "static-4.8968",
  "commerce-tours-lib": "static-1.6946",
  "growth-onboarding-reliability": "static-1.5618",
  "sales-checkout-service-client": "static-1.4057",
  "data-token-picker": "static-1.17220",
  "FileManagerLib": "static-1.40570",
  "content-media-compositions": "static-2.17693",
  "media-bridge-lib": "static-1.19726",
  "chatspot-widget-iframe": "static-1.24254",
  "collaboration-sidebar-common": "static-1.3964",
  "marketing-platform-lib": "static-1.7446",
  "dnd-kit": "static-1.23",
  "commerce-subscription-lib": "static-1.38164",
  "crm-actions": "static-1.6946",
  "crm-cards-sdk": "static-1.45192",
  "customer-data-properties-shared-msw-handlers": "static-1.10326",
  "customer-data-tracking": "static-1.7406",
  "calling-global-api": "static-1.66496",
  "calling-internal-common": "static-1.31857",
  "calling-lifecycle-internal": "static-1.67878",
  "calling-lifecycle-messages": "static-1.60170",
  "commerce-products-lib": "static-1.11087",
  "conditional-properties-service-client": "static-1.4148",
  "crm-index-visualization-core": "static-1.4847",
  "crm-links": "static-1.6862",
  "crm-pipelines-api-client-types": "static-1.4482",
  "formula-editor": "static-1.15080",
  "google-libphonenumber": "static-1.52",
  "inbounddb-objects-service-types": "static-1.4552",
  "meetings-icalendar-utils-lib": "static-1.1170",
  "multi-currency-client-types": "static-1.4047",
  "object-builder-ui-client": "static-1.50210",
  "pipeline-validation-client-types": "static-1.4320",
  "react-tinymce": "static-1.56369",
  "smart-data-capture-core": "static-1.605",
  "tiered-pricing": "static-1.2384",
  "tinymce-config": "static-2.55495",
  "tinymce-plugins": "static-1.58609",
  "tinymce-themes": "static-1.57465",
  "topics-actions-lib": "static-1.728",
  "trellis-ext-i18n": "static-1.1476",
  "ui-addon-form-validation": "static-1.11352",
  "zustand": "static-1.92",
  "fdsr-migration-layer": "static-1.548",
  "permissions-shared-i18n-strings-fe": "static-1.2145",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11082",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11145",
  "sales-views-client-types": "static-1.4793",
  "breeze-sharing-core": "static-1.96",
  "dompurify": "static-1.15",
  "utility-belt": "static-1.3070",
  "growth-data-modal": "static-1.6213",
  "growth-onboarding-confetti": "static-1.3591",
  "growth-onboarding-next-action-utils": "static-1.3094",
  "onboarding-tours-utils": "static-1.1545",
  "ui-shepherd-tracker": "static-1.8203",
  "crm-index-associations-lib": "static-1.6985",
  "academy-service-client": "static-1.4228",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40429",
  "SafeStorage": "static-1.4930",
  "video-embed": "static-1.37037",
  "redux-actions": "static-3.76",
  "EmailSignatureEditor": "static-1.25344",
  "viral-links-lib": "static-1.7617",
  "campaign-roi-lib": "static-1.11009",
  "campaigns-utils-lib": "static-1.3804",
  "ui-addon-calendars": "static-2.5908",
  "nested-table": "static-1.757",
  "timezone-utils": "static-2.5761",
  "getting-started-shared-tasks-store": "static-1.18773",
  "customer-data-views-management": "static-1.26457",
  "framework-data-table": "static-2.12940",
  "nudge-custom-ui-functions": "static-1.1817",
  "switchboard-lib": "static-1.781",
  "app-users-service-client": "static-1.6155",
  "app-users-service-types": "static-1.5563",
  "mini-checkout-client": "static-1.27961",
  "onboarding-utils": "static-1.5910",
  "ui-coaching-tips-shared-config": "static-1.29623",
  "checkout-sdk": "static-3.24804",
  "payment-method-components": "static-1.7375",
  "touchless-buying-components": "static-1.6672",
  "upgrade-catalog-service-types": "static-1.3908",
  "pricing-pages-ui-components": "static-1.16804",
  "edison-service-client-types": "static-1.926",
  "framework-data-schema-quick-fetch": "static-1.7334",
  "growth-onboarding-feedback-components": "static-1.7120",
  "audio-components": "static-1.6648",
  "FileManagerImages": "static-1.38081",
  "video-components": "static-1.14547",
  "js-cookie": "static-1.18",
  "commerce-billing-lib": "static-1.20611",
  "commerce-shared-components-lib": "static-1.19688",
  "commerce-tools-ui-lib": "static-1.11429",
  "crm_data": "static-4.93349",
  "crm-activity-creator-data": "static-1.47901",
  "crm-fe-perf": "static-1.23437",
  "universal-record-utils-lib": "static-1.2494",
  "calling-error-reporting": "static-1.31864",
  "shared-worker-versioning": "static-1.11575",
  "calling-usage-tracker": "static-1.7076",
  "voice-sms-access-library": "static-1.2605",
  "commerce-permissions": "static-1.1318",
  "products-iframe-lib": "static-1.9052",
  "products-ui-components-shared-msw-handlers": "static-1.11382",
  "bark-lib": "static-1.17069",
  "browser-prettier": "static-1.11",
  "tinymce": "static-5.11",
  "hub-http-contrib": "static-1.3565",
  "interframe": "static-3.5280",
  "tinymce-data": "static-1.41580",
  "ui-addon-sales-email": "static-1.5742",
  "layout-dnd-components": "static-1.13315",
  "layout-dnd-utils": "static-1.12290",
  "ui-brand-identity-lib": "static-1.17092",
  "NamespacedHubStyle": "static-2.9405",
  "onboarding-data-sync-lib": "static-1.2919",
  "growth-onboarding-next-action-components": "static-1.3122",
  "user-context-client": "static-1.5042",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.67",
  "urlinator": "static-1.5052",
  "outpost": "static-1.4661",
  "draft-convert": "static-2.87",
  "draft-extend": "static-3.90",
  "draft-js": "static-5.92",
  "draft-plugins": "static-2.22446",
  "sales-email-signature-service-client": "static-1.4381",
  "copilot-messaging": "static-1.2511",
  "ts-utils-lib": "static-1.689",
  "crm-export-dialog": "static-1.6814",
  "crm-index-ui-shimmer": "static-1.3124",
  "crm-view-components": "static-1.1644",
  "react-beautiful-dnd": "static-1.77",
  "customer-data-associations": "static-1.7879",
  "tasks-actions-lib": "static-1.557",
  "InboxConnectUtils": "static-4.15951",
  "emoji-regex": "static-1.7",
  "hub-http-rxjs": "static-1.894",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4526",
  "company-details-components": "static-1.6744",
  "react-performance-metrics-lib": "static-1.1086",
  "quote-checkout-service-types": "static-1.3995",
  "pricing-pages-api": "static-1.16670",
  "social-insights-client-types": "static-1.23038",
  "crm-command-handler-types": "static-1.192",
  "payments-enrollment-embed-lib": "static-1.24395",
  "stripe-embedded-components": "static-1.8331",
  "customer-data-rte": "static-1.33996",
  "cv-backend-services": "static-1.1620",
  "growth-onboarding-empty-states": "static-1.6624",
  "payments-post-enroll-local-storage-lib": "static-1.5635",
  "qrcode-generator": "static-1.82",
  "quotes-client-types": "static-1.39282",
  "crm_universal": "static-1.22807",
  "customer-data-email": "static-1.18731",
  "meetings-rte-lib": "static-1.632",
  "universal-associations-select": "static-1.11640",
  "crm-object-search-query-utilities": "static-1.10562",
  "calling-orchestration-schema": "static-1.37382",
  "react-reducer-toolkit": "static-1.16767",
  "ContentData": "static-1.69689",
  "layout-data-lib": "static-1.10615",
  "meetings-connect-utils-lib": "static-1.8154",
  "company-details-service-types": "static-1.4475",
  "segments-query-core": "static-1.1962",
  "stripe-connect-js": "static-1.85",
  "draft-content-plugins": "static-1.29249",
  "sequences-lib": "static-1.8868",
  "ui-gdpr-components": "static-1.10658",
  "meetings-client-types": "static-1.4123",
  "meetings-core": "static-1.854",
  "advanced-menus-core": "static-1.15906",
  "advanced-menus-lib": "static-1.12636",
  "ui-memberships-settings-lib": "static-1.35323",
  "sequences-client-types-lib": "static-1.8725",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15905",
  "simple-menus-lib": "static-1.17422"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13608",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.1321",
  "client-types": "/client-types/static-1.522",
  "data-fetching-client": "/data-fetching-client/static-1.10170",
  "foundations-components": "/foundations-components/static-1.8846",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1871",
  "foundations-theming": "/foundations-theming/static-1.5036",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.95",
  "head-dlb": "/head-dlb/static-1.5344",
  "hs-test-utils": "/hs-test-utils/static-1.8577",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10999",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.12024",
  "I18n": "/I18n/static-7.1723",
  "jasmine-runner": "/jasmine-runner/static-1.6993",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.1000",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13671",
  "quartz": "/quartz/static-1.7753",
  "react-dlb": "/react-dlb/static-1.96",
  "react-rhumb": "/react-rhumb/static-1.17272",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3384",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11556",
  "reselect": "/reselect/static-3.19",
  "settings-ui-lib": "/settings-ui-lib/static-1.13067",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7935",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11682",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10063",
  "unified-auth": "/unified-auth/static-1.1368",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1650",
  "usage-tracker": "/usage-tracker/static-1.7877",
  "usage-tracker-core": "/usage-tracker-core/static-1.7727",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8594",
  "hub-http": "/hub-http/static-1.6740",
  "integrations-lib": "/integrations-lib/static-1.17557",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21151",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.1137",
  "property-management-iframe": "/property-management-iframe/static-1.14605",
  "quartz-config": "/quartz-config/static-1.1531",
  "quartz-core": "/quartz-core/static-1.6972",
  "quartz-routing": "/quartz-routing/static-1.1183",
  "quick-fetch": "/quick-fetch/static-1.4265",
  "react": "/react/static-7.204",
  "rpc-client-utils": "/rpc-client-utils/static-1.5201",
  "ts-schema": "/ts-schema/static-1.4431",
  "ui-universal-auth": "/ui-universal-auth/static-1.9854",
  "UIComponents": "/UIComponents/static-3.8970",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.529",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6102",
  "PortalIdParser": "/PortalIdParser/static-2.459",
  "raven": "/raven/static-3.6435",
  "raven-hubspot": "/raven-hubspot/static-1.6742",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.4030",
  "quartz-webpack": "/quartz-webpack/static-1.3977",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.831",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10124",
  "codemirror": "/codemirror/static-5.108",
  "foundations-assets": "/foundations-assets/static-1.5424",
  "pulse": "/pulse/static-1.1201",
  "react-codemirror": "/react-codemirror/static-1.11177",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.1101",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5115",
  "floating-ui": "/floating-ui/static-1.70",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2752",
  "framer-motion": "/framer-motion/static-1.86",
  "hs-story-utils": "/hs-story-utils/static-1.9959",
  "react-aria": "/react-aria/static-1.79",
  "react-create-root-preference": "/react-create-root-preference/static-1.120",
  "react-select-plus": "/react-select-plus/static-1.120",
  "react-utils": "/react-utils/static-2.5714",
  "react-virtualized": "/react-virtualized/static-2.114",
  "StyleGuideUI": "/StyleGuideUI/static-3.520",
  "tanstack-table": "/tanstack-table/static-1.68",
  "trellis-assets": "/trellis-assets/static-1.3253",
  "ui-fonts": "/ui-fonts/static-1.1286",
  "ui-images": "/ui-images/static-2.1295",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3519",
  "foundations-theming-base": "/foundations-theming-base/static-1.4021",
  "stylex": "/stylex/static-1.48",
  "HeadJS": "/HeadJS/static-2.836",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3688",
  "msw": "/msw/static-1.105",
  "msw-config": "/msw-config/static-1.41",
  "testing-library": "/testing-library/static-1.167",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.237",
  "moment-timezone": "/moment-timezone/static-5.98",
  "jasmine": "/jasmine/static-4.4840",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9157",
  "ai-rendering-library": "/ai-rendering-library/static-1.11540",
  "chirp-fetch": "/chirp-fetch/static-1.2435",
  "connections-embed-lib": "/connections-embed-lib/static-1.1844",
  "copilot-toolkit": "/copilot-toolkit/static-1.12261",
  "feedback-loader": "/feedback-loader/static-1.30145",
  "laboratory-lib": "/laboratory-lib/static-3.7683",
  "marketplace-embed": "/marketplace-embed/static-1.23304",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.11046",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.21106",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15321",
  "sanitize-text": "/sanitize-text/static-1.8692",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6291",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5563",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.237",
  "quartz-head": "/quartz-head/static-1.1418",
  "web-vitals": "/web-vitals/static-1.21",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5124",
  "immer": "/immer/static-1.107",
  "immerable": "/immerable/static-1.4679",
  "highcharts": "/highcharts/static-8.117",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2897",
  "reporting-data": "/reporting-data/static-1.69623",
  "cssUtils": "/cssUtils/static-1.1158",
  "flux-actions": "/flux-actions/static-1.383",
  "react-colorpicker": "/react-colorpicker/static-2.10744",
  "react-dnd-compat": "/react-dnd-compat/static-1.5145",
  "redux-observable": "/redux-observable/static-1.81",
  "ReduxMessenger": "/ReduxMessenger/static-2.10907",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7867",
  "icons": "/icons/static-2.715",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19683",
  "storybook-react": "/storybook-react/static-1.46",
  "trellis-story-utils": "/trellis-story-utils/static-1.5031",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6329",
  "quartz-i18n": "/quartz-i18n/static-1.1428",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.842",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.2304",
  "ai-mcp-auth-lib": "/ai-mcp-auth-lib/static-1.82",
  "cohere-settings-lib": "/cohere-settings-lib/static-1.10541",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.418",
  "gemini-settings-lib": "/gemini-settings-lib/static-1.9892",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1440",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.638",
  "slack-ui-library": "/slack-ui-library/static-1.10937",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.953",
  "x-ai-settings-lib": "/x-ai-settings-lib/static-1.10600",
  "fsm": "/fsm/static-1.4296",
  "customer-data-objects": "/customer-data-objects/static-1.8249",
  "property-translator": "/property-translator/static-1.5911",
  "hs-locale-management": "/hs-locale-management/static-1.440",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8458",
  "hs-promise-utils": "/hs-promise-utils/static-1.6125",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5411",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14972",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6163",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8293",
  "sanitize": "/sanitize/static-1.5003",
  "superstore": "/superstore/static-1.5290",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10822",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8682",
  "hub-http-janus": "/hub-http-janus/static-1.919",
  "hubspotter-http": "/hubspotter-http/static-1.5011",
  "immutable-less": "/immutable-less/static-1.5183",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18558",
  "nav-meta": "/nav-meta/static-1.30952",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18606",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1803",
  "ai-studio-lib": "/ai-studio-lib/static-1.12904",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19394",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.817",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9615",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8484",
  "ui-product-approvals": "/ui-product-approvals/static-1.29907",
  "ui-tool-access": "/ui-tool-access/static-1.10689",
  "data-agent-kit": "/data-agent-kit/static-1.1045",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4188",
  "property-management-common": "/property-management-common/static-1.6893",
  "smart-property-fill-lib": "/smart-property-fill-lib/static-1.862",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.335",
  "dispatcher": "/dispatcher/static-1.150",
  "general-store": "/general-store/static-6.20",
  "hs-browser-apis": "/hs-browser-apis/static-1.16",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.618",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.710",
  "quartz-auth": "/quartz-auth/static-1.1428",
  "quartz-test": "/quartz-test/static-1.1428",
  "quartz-tracking": "/quartz-tracking/static-1.1132",
  "trellis-components": "/trellis-components/static-1.3272",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.611",
  "HubStyle": "/HubStyle/static-2.12331",
  "bender-build-tools": "/bender-build-tools/static-1.3648",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.24263",
  "ContentUtils": "/ContentUtils/static-1.69614",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13571",
  "sassPrefix": "/sassPrefix/static-1.422",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "batch-promise": "/batch-promise/static-1.2085",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.704",
  "event-emitter": "/event-emitter/static-1.1495",
  "fast-json-patch": "/fast-json-patch/static-1.76",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5958",
  "magpie-types": "/magpie-types/static-1.5418",
  "stylex-utils": "/stylex-utils/static-1.190",
  "trellis-theming": "/trellis-theming/static-1.1576",
  "avatar-components": "/avatar-components/static-1.3023",
  "breeze-engine-core": "/breeze-engine-core/static-1.1657",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2379",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.1210",
  "breeze-upgrade-component-lib": "/breeze-upgrade-component-lib/static-1.49",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41538",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13711",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.537",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16189",
  "ExportDialog": "/ExportDialog/static-6.10909",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.607",
  "highlight.js": "/highlight.js/static-1.92",
  "markdown-it": "/markdown-it/static-1.6",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.1007",
  "mermaid": "/mermaid/static-1.47",
  "reporting-action-components": "/reporting-action-components/static-1.42523",
  "reporting-snowflake": "/reporting-snowflake/static-1.58239",
  "reporting-ui-components": "/reporting-ui-components/static-2.66892",
  "reporting-visualizations": "/reporting-visualizations/static-1.61697",
  "trial-components-library": "/trial-components-library/static-1.14478",
  "ui-addon-teams": "/ui-addon-teams/static-1.22074",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.793",
  "navigation-components": "/navigation-components/static-1.19315",
  "nest": "/nest/static-1.773",
  "simple-logging-lib": "/simple-logging-lib/static-1.3582",
  "nudge-client-utils": "/nudge-client-utils/static-1.3507",
  "fail-safe": "/fail-safe/static-1.481",
  "app-governance-lib": "/app-governance-lib/static-1.2839",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11080",
  "purchase-motions-components": "/purchase-motions-components/static-1.6717",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10963",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6294",
  "usage-tracker-public": "/usage-tracker-public/static-1.7688",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.79",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3808",
  "persist-promise": "/persist-promise/static-1.4242",
  "reference-resolvers": "/reference-resolvers/static-1.8721",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4453",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.870",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3555",
  "final-form": "/final-form/static-1.85",
  "redux-toolkit": "/redux-toolkit/static-1.84",
  "simple-data-table": "/simple-data-table/static-1.3933",
  "merchandise-lib": "/merchandise-lib/static-1.289",
  "onboarding-scopes": "/onboarding-scopes/static-1.6987",
  "permissions-summary-ui-lib": "/permissions-summary-ui-lib/static-1.125",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5287",
  "content-assistance-lib": "/content-assistance-lib/static-1.8501",
  "content-media-capture": "/content-media-capture/static-1.5882",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10368",
  "emoji-mart": "/emoji-mart/static-3.9",
  "file-manager-components": "/file-manager-components/static-1.24930",
  "growth-payments-core": "/growth-payments-core/static-1.26622",
  "knowledge-content-types": "/knowledge-content-types/static-1.8767",
  "PatternValidationJS": "/PatternValidationJS/static-1.3411",
  "payment-link-components": "/payment-link-components/static-1.24580",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20641",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10399",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9631",
  "video-components-external": "/video-components-external/static-1.12545",
  "video-data-lib": "/video-data-lib/static-1.36203",
  "navigation-messaging": "/navigation-messaging/static-1.8642",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.59167",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.632",
  "policy-lib": "/policy-lib/static-1.7339",
  "crm-component-utils": "/crm-component-utils/static-1.40332",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6432",
  "customer-data-properties": "/customer-data-properties/static-1.53245",
  "external-options-client-types": "/external-options-client-types/static-1.4476",
  "hs-resources": "/hs-resources/static-1.731",
  "property-value-citations": "/property-value-citations/static-1.3859",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8648",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.2023",
  "crm-message-bus": "/crm-message-bus/static-1.44254",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.589",
  "data-agent-usage-based-billing": "/data-agent-usage-based-billing/static-1.232",
  "data-agent-utils": "/data-agent-utils/static-1.1058",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.403",
  "smart-property-lib": "/smart-property-lib/static-1.8844",
  "opentelemetry-web": "/opentelemetry-web/static-1.25",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10997",
  "base-ui": "/base-ui/static-1.31",
  "react-day-picker": "/react-day-picker/static-1.17",
  "tanstack-virtual": "/tanstack-virtual/static-1.45",
  "cms-field-types": "/cms-field-types/static-1.5348",
  "content-icons-ui": "/content-icons-ui/static-1.2519",
  "atom": "/atom/static-1.5608",
  "idb-keyval": "/idb-keyval/static-1.57",
  "reactive-lib": "/reactive-lib/static-1.1257",
  "trellis-migration-context": "/trellis-migration-context/static-1.113",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1357",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1194",
  "breeze-assistant-components": "/breeze-assistant-components/static-1.2751",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19655",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1350",
  "interactive-cards": "/interactive-cards/static-1.616",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7648",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23973",
  "events-data-lib": "/events-data-lib/static-1.788",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5249",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4372",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1555",
  "onboarding-tours": "/onboarding-tours/static-1.17478",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14868",
  "segments-client-types": "/segments-client-types/static-1.12376",
  "academy-common-lib": "/academy-common-lib/static-1.15650",
  "dashboard-lib": "/dashboard-lib/static-1.83458",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19386",
  "reporting-plugins": "/reporting-plugins/static-1.11098",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9249",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4796",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11644",
  "user-context": "/user-context/static-1.5593",
  "reporting-reports": "/reporting-reports/static-1.69299",
  "hubs-service-types": "/hubs-service-types/static-1.1801",
  "purchase-motions-api": "/purchase-motions-api/static-1.6720",
  "salesImages": "/salesImages/static-1.793",
  "signup-constants": "/signup-constants/static-1.20109",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3264",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3583",
  "whisper-core-api": "/whisper-core-api/static-1.7733",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.432",
  "framework-listing-lib": "/framework-listing-lib/static-2.29938",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31871",
  "apps-service-types": "/apps-service-types/static-1.4143",
  "oauth-service-types": "/oauth-service-types/static-1.4671",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8570",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5693",
  "one-click-checkout": "/one-click-checkout/static-1.866",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.8037",
  "purchasing-components-lib": "/purchasing-components-lib/static-1.1118",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15517",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.221",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3893",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7429",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10551",
  "redux-thunk": "/redux-thunk/static-2.87",
  "seat-types-lib": "/seat-types-lib/static-1.1165",
  "react-flip-move": "/react-flip-move/static-1.85",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29638",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13686",
  "fix-webm-duration": "/fix-webm-duration/static-1.36",
  "notification-sounds": "/notification-sounds/static-1.4964",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "poll-commands": "/poll-commands/static-1.4011",
  "ui-addon-opt": "/ui-addon-opt/static-4.8968",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6946",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5618",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4057",
  "data-token-picker": "/data-token-picker/static-1.17220",
  "FileManagerLib": "/FileManagerLib/static-1.40570",
  "content-media-compositions": "/content-media-compositions/static-2.17693",
  "media-bridge-lib": "/media-bridge-lib/static-1.19726",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.24254",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3964",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7446",
  "dnd-kit": "/dnd-kit/static-1.23",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38164",
  "crm-actions": "/crm-actions/static-1.6946",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.45192",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10326",
  "customer-data-tracking": "/customer-data-tracking/static-1.7406",
  "calling-global-api": "/calling-global-api/static-1.66496",
  "calling-internal-common": "/calling-internal-common/static-1.31857",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67878",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.60170",
  "commerce-products-lib": "/commerce-products-lib/static-1.11087",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4148",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4847",
  "crm-links": "/crm-links/static-1.6862",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4482",
  "formula-editor": "/formula-editor/static-1.15080",
  "google-libphonenumber": "/google-libphonenumber/static-1.52",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4552",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1170",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4047",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50210",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4320",
  "react-tinymce": "/react-tinymce/static-1.56369",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.605",
  "tiered-pricing": "/tiered-pricing/static-1.2384",
  "tinymce-config": "/tinymce-config/static-2.55495",
  "tinymce-plugins": "/tinymce-plugins/static-1.58609",
  "tinymce-themes": "/tinymce-themes/static-1.57465",
  "topics-actions-lib": "/topics-actions-lib/static-1.728",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1476",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11352",
  "zustand": "/zustand/static-1.92",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.548",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2145",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11082",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11145",
  "sales-views-client-types": "/sales-views-client-types/static-1.4793",
  "breeze-sharing-core": "/breeze-sharing-core/static-1.96",
  "dompurify": "/dompurify/static-1.15",
  "utility-belt": "/utility-belt/static-1.3070",
  "growth-data-modal": "/growth-data-modal/static-1.6213",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3591",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3094",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1545",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8203",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6985",
  "academy-service-client": "/academy-service-client/static-1.4228",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40429",
  "SafeStorage": "/SafeStorage/static-1.4930",
  "video-embed": "/video-embed/static-1.37037",
  "redux-actions": "/redux-actions/static-3.76",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25344",
  "viral-links-lib": "/viral-links-lib/static-1.7617",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.11009",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3804",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5908",
  "nested-table": "/nested-table/static-1.757",
  "timezone-utils": "/timezone-utils/static-2.5761",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18773",
  "customer-data-views-management": "/customer-data-views-management/static-1.26457",
  "framework-data-table": "/framework-data-table/static-2.12940",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1817",
  "switchboard-lib": "/switchboard-lib/static-1.781",
  "app-users-service-client": "/app-users-service-client/static-1.6155",
  "app-users-service-types": "/app-users-service-types/static-1.5563",
  "mini-checkout-client": "/mini-checkout-client/static-1.27961",
  "onboarding-utils": "/onboarding-utils/static-1.5910",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29623",
  "checkout-sdk": "/checkout-sdk/static-3.24804",
  "payment-method-components": "/payment-method-components/static-1.7375",
  "touchless-buying-components": "/touchless-buying-components/static-1.6672",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3908",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16804",
  "edison-service-client-types": "/edison-service-client-types/static-1.926",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7334",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7120",
  "audio-components": "/audio-components/static-1.6648",
  "FileManagerImages": "/FileManagerImages/static-1.38081",
  "video-components": "/video-components/static-1.14547",
  "js-cookie": "/js-cookie/static-1.18",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20611",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19688",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11429",
  "crm_data": "/crm_data/static-4.93349",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.47901",
  "crm-fe-perf": "/crm-fe-perf/static-1.23437",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2494",
  "calling-error-reporting": "/calling-error-reporting/static-1.31864",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11575",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7076",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2605",
  "commerce-permissions": "/commerce-permissions/static-1.1318",
  "products-iframe-lib": "/products-iframe-lib/static-1.9052",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11382",
  "bark-lib": "/bark-lib/static-1.17069",
  "browser-prettier": "/browser-prettier/static-1.11",
  "tinymce": "/tinymce/static-5.11",
  "hub-http-contrib": "/hub-http-contrib/static-1.3565",
  "interframe": "/interframe/static-3.5280",
  "tinymce-data": "/tinymce-data/static-1.41580",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5742",
  "layout-dnd-components": "/layout-dnd-components/static-1.13315",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12290",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17092",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9405",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2919",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3122",
  "user-context-client": "/user-context-client/static-1.5042",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.67",
  "urlinator": "/urlinator/static-1.5052",
  "outpost": "/outpost/static-1.4661",
  "draft-convert": "/draft-convert/static-2.87",
  "draft-extend": "/draft-extend/static-3.90",
  "draft-js": "/draft-js/static-5.92",
  "draft-plugins": "/draft-plugins/static-2.22446",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4381",
  "copilot-messaging": "/copilot-messaging/static-1.2511",
  "ts-utils-lib": "/ts-utils-lib/static-1.689",
  "crm-export-dialog": "/crm-export-dialog/static-1.6814",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.3124",
  "crm-view-components": "/crm-view-components/static-1.1644",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.77",
  "customer-data-associations": "/customer-data-associations/static-1.7879",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.557",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15951",
  "emoji-regex": "/emoji-regex/static-1.7",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.894",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4526",
  "company-details-components": "/company-details-components/static-1.6744",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.1086",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3995",
  "pricing-pages-api": "/pricing-pages-api/static-1.16670",
  "social-insights-client-types": "/social-insights-client-types/static-1.23038",
  "crm-command-handler-types": "/crm-command-handler-types/static-1.192",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24395",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8331",
  "customer-data-rte": "/customer-data-rte/static-1.33996",
  "cv-backend-services": "/cv-backend-services/static-1.1620",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6624",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5635",
  "qrcode-generator": "/qrcode-generator/static-1.82",
  "quotes-client-types": "/quotes-client-types/static-1.39282",
  "crm_universal": "/crm_universal/static-1.22807",
  "customer-data-email": "/customer-data-email/static-1.18731",
  "meetings-rte-lib": "/meetings-rte-lib/static-1.632",
  "universal-associations-select": "/universal-associations-select/static-1.11640",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10562",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37382",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16767",
  "ContentData": "/ContentData/static-1.69689",
  "layout-data-lib": "/layout-data-lib/static-1.10615",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8154",
  "company-details-service-types": "/company-details-service-types/static-1.4475",
  "segments-query-core": "/segments-query-core/static-1.1962",
  "stripe-connect-js": "/stripe-connect-js/static-1.85",
  "draft-content-plugins": "/draft-content-plugins/static-1.29249",
  "sequences-lib": "/sequences-lib/static-1.8868",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10658",
  "meetings-client-types": "/meetings-client-types/static-1.4123",
  "meetings-core": "/meetings-core/static-1.854",
  "advanced-menus-core": "/advanced-menus-core/static-1.15906",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12636",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35323",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8725",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15905",
  "simple-menus-lib": "/simple-menus-lib/static-1.17422"
}
};
